module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_0.9efe9303.png";